import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createBlock as _createBlock, withModifiers as _withModifiers, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fd38df18"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "shape-element-operate" }

import { computed, PropType } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore } from '@/store'
import { PPTShapeElement } from '@/types/slides'
import { OperateResizeHandlers } from '@/types/edit'
import { SHAPE_PATH_FORMULAS } from '@/configs/shapes'
import useCommonOperate from '../hooks/useCommonOperate'

import RotateHandler from './RotateHandler.vue'
import ResizeHandler from './ResizeHandler.vue'
import BorderLine from './BorderLine.vue'


const __default__ = {
  inheritAttrs: false,
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'ShapeElementOperate',
  props: {
  elementInfo: {
    type: Object as PropType<PPTShapeElement>,
    required: true,
  },
  handlerVisible: {
    type: Boolean,
    required: true,
  },
  rotateElement: {
    type: Function as PropType<(element: PPTShapeElement) => void>,
    required: true,
  },
  scaleElement: {
    type: Function as PropType<(e: MouseEvent, element: PPTShapeElement, command: OperateResizeHandlers) => void>,
    required: true,
  },
  moveShapeKeypoint: {
    type: Function as PropType<(e: MouseEvent, element: PPTShapeElement) => void>,
    required: true,
  },
},
  setup(__props) {

const props = __props



const { canvasScale } = storeToRefs(useMainStore())

const scaleWidth = computed(() => props.elementInfo.width * canvasScale.value)
const scaleHeight = computed(() => props.elementInfo.height * canvasScale.value)
const { resizeHandlers, borderLines } = useCommonOperate(scaleWidth, scaleHeight)

const keypointStyle = computed(() => {
  if (!props.elementInfo.pathFormula || !props.elementInfo.keypoint) return {}

  const pathFormula = SHAPE_PATH_FORMULAS[props.elementInfo.pathFormula]
  if ('editable' in pathFormula) {
    const keypointPos = pathFormula.getBaseSize(props.elementInfo.width, props.elementInfo.height) * props.elementInfo.keypoint
    if (pathFormula.relative === 'left') return { left: keypointPos * canvasScale.value + 'px' }
    if (pathFormula.relative === 'right') return { left: (props.elementInfo.width - keypointPos) * canvasScale.value + 'px' }
    if (pathFormula.relative === 'center') return { left: (props.elementInfo.width - keypointPos) / 2 * canvasScale.value + 'px' }
    if (pathFormula.relative === 'top') return { top: keypointPos * canvasScale.value + 'px' }
    if (pathFormula.relative === 'bottom') return { top: (props.elementInfo.height - keypointPos) * canvasScale.value + 'px' }
  }
  return {}
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(borderLines), (line) => {
      return (_openBlock(), _createBlock(BorderLine, {
        class: "operate-border-line",
        key: line.type,
        type: line.type,
        style: _normalizeStyle(line.style)
      }, null, 8, ["type", "style"]))
    }), 128)),
    (__props.handlerVisible)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(resizeHandlers), (point) => {
            return (_openBlock(), _createBlock(ResizeHandler, {
              class: "operate-resize-handler",
              key: point.direction,
              type: point.direction,
              rotate: __props.elementInfo.rotate,
              style: _normalizeStyle(point.style),
              onMousedown: _withModifiers($event => __props.scaleElement($event, __props.elementInfo, point.direction), ["stop"])
            }, null, 8, ["type", "rotate", "style", "onMousedown"]))
          }), 128)),
          _createVNode(RotateHandler, {
            class: "operate-rotate-handler",
            style: _normalizeStyle({ left: _unref(scaleWidth) / 2 + 'px' }),
            onMousedown: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (__props.rotateElement(__props.elementInfo)), ["stop"]))
          }, null, 8, ["style"]),
          (__props.elementInfo.keypoint !== undefined)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "operate-keypoint-handler",
                style: _normalizeStyle(_unref(keypointStyle)),
                onMousedown: _cache[1] || (_cache[1] = _withModifiers($event => __props.moveShapeKeypoint($event, __props.elementInfo), ["stop"]))
              }, null, 36))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true)
  ]))
}
}

})